import { fulfilled, useSettledPromise } from '@fluidx/layer-agnostic-react-hooks';
export { useSettledPromise };
/**
 * Returns the value of a resolved promise,
 * or undefined if the promise is pending or rejected.
 * @param promise Promise to await.
 * @example
 * const result = useResolvedPromise(networkResponse);
 * if (result !== undefined) {
 *   return <span>{result}</span>;
 * } else {
 *   return <LoadingSpinner />;
 * }
 */ export function useResolvedPromise(promise) {
    return fulfilled(useSettledPromise(promise));
}
